module.exports = __webpack_public_path__ + "static/media/dcs_logo.0a2a9ee4.png";


//////////////////
// WEBPACK FOOTER
// ./src/dcs_logo.png
// module id = 167
// module chunks = 0